<template>
  <fire-safety-docs-plate
      :data="childItems"
  ></fire-safety-docs-plate>
</template>

<script>
import FireSafetyDocsPlate from "./FireSafetyDocsPlate.vue";
export default {
  components: { FireSafetyDocsPlate },
  props: {
    items: {
      type: Object,
      default() {
        return {
          "title": "СТО 04416677-002-2022 Здания общеобразовательных организаций (школ) до 2-х этажей",
          "url": "https://google.com",
          "documentType": "PDF",
          "documentSize": "841 кб"
        };
      }
    }
  },
  data() {
    return {
      childItems: []
    };
  },
  mounted() {
    if (this.items && this.items.items && this.items.items.length) {
      this.items.items.forEach((item) => {
        const fileInfo = {};
        if (item.file) {
          fileInfo.url = item.file.src;
          fileInfo.documentType = item.file.extension.toUpperCase();
          fileInfo.documentSize = item.file.size;
        }
        this.childItems.push({
          title: item.name,
          ...fileInfo
        });
      });
    }
  }
}
</script>